<template>
  <div style="padding: 10px">
    <v-app-bar flat color="white">
      <v-spacer/>
      <v-app-bar-title class="centered-title">{{$t("GroupedBarChart.accumulatedHours")}} {{ pageNumber }}</v-app-bar-title>
      <v-progress-circular
        class="loading-icon"
        v-if="loading"
        indeterminate
        size="20"
        width="3"
        color="#0098E1"
      ></v-progress-circular>
      <v-spacer/>
    </v-app-bar>
    <apexchart type="bar" height="410px" class="grouped-bar-content" :options="chartOptions" :series="series"></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import {makeFetchQueryRequest} from '../../lib/helpers'
import {auth} from '../../plugins/firebase'
export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ['limit', 'offset', 'pageNumber', 'timeRange', 'organizationId', 'equipmentsData'],
  data () {
    return {
      series: [{
        data: []
      }, {
        data: []
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 410
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetX: -6,
          style: {
            fontSize: '12px',
            colors: ['#fff']
          }
        },
        stroke: {
          show: true,
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: []
        }
      },
      loading: false
    }
  },
  created () {
    this.getDataTable(this.timeRange.from, this.timeRange.to, this.organizationId)
  },
  watch: {
    timeRange (value) {
      this.getDataTable(value.from, value.to, this.organizationId)
    },
    organizationId (value) {
      this.getDataTable(this.timeRange.from, this.timeRange.to, value)
    }
  },
  methods: {
    async getDataTable (fromDate, toDate, organizationId) {
      if (!organizationId) {
        organizationId = 'PONCE'
      }
      if (fromDate && toDate) {
        this.loading = true
        let accumulatedHours = []
        let theoricHours = []
        let deviceNames = []
        const fetchBody = {
          type: 'organizationGroupedIrrigationOrders',
          data: {
            organizationId,
            fromDate: fromDate.getTime(),
            toDate: toDate.getTime()
          }
        }
        try {
          const res = await makeFetchQueryRequest(fetchBody, auth.currentUser)
          res.forEach((elem) => {
            let theoricHoursValue = elem.theoricHours
            let accumulatedHoursValue = elem.diffTimeHours
            if (theoricHoursValue) {
              theoricHoursValue = theoricHoursValue.toFixed(2)
            }
            if (accumulatedHoursValue) {
              accumulatedHoursValue = accumulatedHoursValue.toFixed(2)
            }
            theoricHours.push(theoricHoursValue)
            accumulatedHours.push(accumulatedHoursValue)
            deviceNames.push(elem.deviceName)
          })
          theoricHours = theoricHours.slice(this.offset, this.offset + this.limit)
          accumulatedHours = accumulatedHours.slice(this.offset, this.offset + this.limit)
          deviceNames = deviceNames.slice(this.offset, this.offset + this.limit)
          this.chartOptions = {...this.chartOptions,
            ...{
              xaxis: {
                categories: deviceNames
              }
            }}
          this.series = [{
            name: this.$t('GroupedBarChart.accumulatedHours'),
            data: accumulatedHours
          }, {
            name: this.$t('GroupedBarChart.theoricHours'),
            data: theoricHours
          }]
          this.$emit('update:equipmentsData', {
            theoricHours: theoricHours,
            accumulatedHours: accumulatedHours,
            deviceNames: deviceNames
          })
        } catch (error) {
          console.log(error.message)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// GroupedBarChart.vue?3714155f